import {
  Box, Typography, Button, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Chip, IconButton, Tooltip,
  CircularProgress,
} from "@mui/material";
import { Add, Edit, Delete, OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useGetCmsPagesQuery, useDeleteCmsPageMutation } from "../../../app/websiteApiSlice";
import toast from "../../../helpers/toast";

export default function CmsPagesManage() {
  const { data: pages = [], isLoading } = useGetCmsPagesQuery();
  const [deletePage, { isLoading: deleting }] = useDeleteCmsPageMutation();

  async function handleDelete(page) {
    if (!window.confirm(`Delete "${page.title}"?`)) return;
    try {
      await deletePage(page.id).unwrap();
      toast.success("Page deleted");
    } catch (err) {
      toast.error(err?.message || "Failed to delete");
    }
  }

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h5" fontWeight={700}>Pages</Typography>
        <Button variant="contained" startIcon={<Add />} component={Link} to="/cms/pages/new">
          New Page
        </Button>
      </Box>

      {isLoading ? (
        <Box display="flex" justifyContent="center" p={4}><CircularProgress /></Box>
      ) : (
        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ "& th": { fontWeight: 600 } }}>
                <TableCell>Title</TableCell>
                <TableCell>Slug</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pages.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <Typography variant="body2" color="text.secondary" align="center" py={3}>
                      No pages yet. Create your first page!
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {pages.map((page) => (
                <TableRow key={page.id} hover>
                  <TableCell>{page.title}</TableCell>
                  <TableCell>
                    <Typography variant="caption" color="text.secondary">
                      /p/{page.slug}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={page.status}
                      size="small"
                      color={page.status === "published" ? "success" : "default"}
                    />
                  </TableCell>
                  <TableCell align="right">
                    {page.status === "published" && (
                      <Tooltip title="View page">
                        <IconButton size="small" component="a" href={`/p/${page.slug}`} target="_blank">
                          <OpenInNew fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Edit">
                      <IconButton size="small" component={Link} to={`/cms/pages/${page.id}/edit`}>
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton size="small" color="error" onClick={() => handleDelete(page)} disabled={deleting}>
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
